import { AsyncState } from 'widgets-for-react'
import { loadCount } from '../../pagination/paginationApi'
import { getComponentsCount } from '../componentOverview/componentOverviewApi'

export type ComponentsCountLoaderState = AsyncState<number>

export const initialComponentsCountLoaderState: ComponentsCountLoaderState =
  loadCount(getComponentsCount)
